<template>
  <div>
    <div class="d-flex">
      <div class="side-frame-success"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          No：{{ formData.amzFtyOutboundNo || 'New' }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <el-tag
          size="mini"
          :type="
            formData.amzFtyOutboundStatus == 'Y'
              ? 'success'
              : formData.amzFtyOutboundStatus == 'D'
              ? 'danger'
              : ''
          "
        >
          {{ formData.v_amzFtyOutboundStatus || 'New' }}
        </el-tag>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Modify：{{ formData.modifyByName || '--' }} at
          {{ formData.modifyDate || '--' }}
        </span>
      </div>
    </div>
    <el-form
      ref="baseForm"
      size="mini"
      :model="formData"
      :rules="formRules"
      :disabled="disabled"
      :validate-on-rule-change="false"
    >
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_bookContractNo') || '外运单号'"
            prop="bookContractNo"
          >
            <el-input
              v-model.trim="formData.bookContractNo"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              maxlength="50"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_cust') || '下单客户'"
            prop="custCode"
          >
            <dict-select
              v-model="formData.custCode"
              ref="custRef"
              @loaded="custLoaded"
              url="/master/common/dict/customerSelect"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              size="mini"
              clearable
              filterable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_endCust') || '终端客户'"
            prop="endCustCode"
          >
            <dict-select
              v-model="formData.endCustCode"
              url="/master/common/dict/customerSelect"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              size="mini"
              clearable
              filterable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_buyer') || '跟单业务'"
            prop="buyerCode"
          >
            <dict-select
              v-model="formData.buyerCode"
              url="/master/common/dict/baseUserSelect"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              :selectedLabel.sync="formData.buyerName"
              size="mini"
              clearable
              filterable
              @change="buyerChange"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item
            :label="$l('form_label_amazonStoreRegion') || '店铺区域'"
            prop="amazonStoreRegion"
          >
            <dict-select
              v-model="formData.amazonStoreRegion"
              url="/ecom/amz/market/dictSelect"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              :selectedLabel.sync="formData.v_amazonStoreRegion"
              size="mini"
              clearable
              filterable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item
            :label="$l('form_label_region') || '所属地区'"
            prop="regionCode"
          >
            <dict-select
              v-model="formData.regionCode"
              url="/master/common/dict/biz"
              :body="regionParams"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              :selectedLabel.sync="formData.regionName"
              size="mini"
              clearable
              filterable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item
            :label="$l('form_label_shipPlanType') || '发运类型'"
            prop="shipPlanType"
          >
            <dict-select
              v-model="formData.shipPlanType"
              url="/master/common/dict/biz"
              :body="shipPlanTypeParams"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              size="mini"
              clearable
              filterable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item
            :label="$l('form_label_shipmentByFactory') || '是否工厂发货'"
            prop="shipmentByFactory"
          >
            <el-select
              v-model="formData.shipmentByFactory"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              size="mini"
              filterable
              @change="shipmentByFactoryChange"
              style="width: 100%;"
            >
              <el-option
                value="Y"
                :label="$l('form_label_shipmentByFactory_y') || '是'"
              >
              </el-option>
              <el-option
                value="N"
                :label="$l('form_label_shipmentByFactory_n') || '否'"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_scm') || '供应商'"
            prop="scmCode"
          >
            <dict-select
              v-model="formData.scmCode"
              url="/master/common/dict/scmCooperated"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              :selectedLabel.sync="formData.scmName"
              size="mini"
              filterable
              clearable
              @change="scmChange"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_ecomWarehouse') || '出库仓库'"
            prop="ecomWarehouseCode"
            ref="ecomWarehouse"
          >
            <dict-select
              v-if="formData.shipmentByFactory == 'N'"
              v-model="formData.ecomWarehouseCode"
              url="/ecom/warehouse/cn/warehouse/select"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              size="mini"
              filterable
              clearable
              @change="warehouseChange"
            ></dict-select>
            <el-input
              v-if="formData.shipmentByFactory == 'Y'"
              :value="$l('form_label_ecomWarehouse_default') || '工厂仓库'"
              readonly
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_deliveryDate') || '预计进仓日期'"
            prop="deliveryDate"
          >
            <el-date-picker
              v-model="formData.deliveryDate"
              type="date"
              value-format="yyyy-MM-dd"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              clearable
              style="width: 100%;"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>

        <el-col :span="6" v-if="formData.shipmentByFactory == 'N'">
          <el-form-item
            :label="$l('form_label_whContactName') || '仓库联系人'"
            prop="whContactName"
          >
            <el-input
              v-model.trim="formData.whContactName"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              maxlength="50"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="6" v-if="formData.shipmentByFactory == 'N'">
          <el-form-item
            :label="$l('form_label_whContactMobile') || '仓库联系人手机'"
            prop="whContactMobile"
          >
            <el-input
              v-model.trim="formData.whContactMobile"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              maxlength="50"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="6" v-if="formData.shipmentByFactory == 'N'">
          <el-form-item
            :label="$l('form_label_whContactEmail') || '仓库联系人邮箱'"
            prop="whContactEmail"
          >
            <el-input
              v-model.trim="formData.whContactEmail"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              maxlength="50"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="6" v-if="formData.shipmentByFactory == 'Y'">
          <el-form-item
            :label="$l('form_label_scmContactName') || '供应商联系人'"
            prop="scmContactName"
          >
            <el-input
              v-model.trim="formData.scmContactName"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              maxlength="50"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="6" v-if="formData.shipmentByFactory == 'Y'">
          <el-form-item
            :label="$l('form_label_scmContactMobile') || '供应商联系人手机'"
            prop="scmContactMobile"
          >
            <el-input
              v-model.trim="formData.scmContactMobile"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              maxlength="50"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="6" v-if="formData.shipmentByFactory == 'Y'">
          <el-form-item
            :label="$l('form_label_scmContactEmail') || '供应商联系人邮箱'"
            prop="scmContactEmail"
          >
            <el-input
              v-model.trim="formData.scmContactEmail"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              maxlength="50"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_operationRequirement') || '作业内容'"
            prop="operationRequirement"
          >
            <el-input
              v-model="formData.operationRequirement"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              :autosize="{ minRows: 2, maxRows: 4 }"
              type="textarea"
              maxlength="1000"
              clearable
              show-word-limit
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="d-flex mt-2">
      <div class="side-frame-warning"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          {{ $l('form_group_title') || '送货确认信息' }}
        </span>
      </div>
    </div>
    <el-form
      ref="carrierForm"
      size="mini"
      :model="formData"
      :rules="formRules"
      :disabled="disabled"
      :validate-on-rule-change="false"
    >
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_comfirmDeliveryDate') || '确认送达日期'"
            prop="comfirmDeliveryDate"
          >
            <el-date-picker
              v-model="formData.comfirmDeliveryDate"
              type="date"
              value-format="yyyy-MM-dd"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              clearable
              style="width: 100%;"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item
            :label="$l('form_label_carrierName') || '运输车牌号（快递公司）'"
            prop="carrierName"
          >
            <el-input
              v-model="formData.carrierName"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              maxlength="200"
              clearable
              show-word-limit
            />
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item
            :label="
              $l('form_label_carrierInfo') || '司机姓名及电话（快递单号）'
            "
            prop="carrierInfo"
          >
            <el-input
              v-model="formData.carrierInfo"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              maxlength="200"
              clearable
              show-word-limit
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <SkuTable
      ref="skuTable"
      class="mt-1"
      :amazonStoreRegion="formData.amazonStoreRegion"
      :amazonStoreRegionName="formData.v_amazonStoreRegion"
      :regionCode="formData.regionCode"
      :regionName="formData.regionName"
      :scmCode="formData.scmCode"
      :scmName="formData.scmName"
      :ecomWarehouseCode="formData.ecomWarehouseCode"
      :shipmentByFactory="formData.shipmentByFactory"
      :amzFtyOutboundCode="amzFtyOutboundCode"
      :disabled="disabled"
    />

    <ChooseScmContacts
      :visible.sync="chooseScmContactsVisible"
      :title="
        `${formData.scmName}-${$l('dialog_title_chooseScmContacts') ||
          '联系人'}`
      "
      :scmCode="formData.scmCode"
      @confirm="scmContactsConfirm"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import validate from '@/libs/util.validate'
import { request } from '@/api/service'
import EditLoading from '@/mixins/edit-loading'
import SkuTable from '../sku-table'
import ChooseScmContacts from '@/views/ecom/components/choose-scm-contacts'
export default {
  mixins: [EditLoading],
  components: { SkuTable, ChooseScmContacts },
  props: {
    amzFtyOutboundCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      formData: {
        shipmentByFactory: 'N',
        scmCode: '',
        scmContactName: '',
        scmContactMobile: '',
        scmContactEmail: '',
        whContactName: '',
        whContactMobile: '',
        whContactEmail: '',
        operationRequirement: '',
        buyerName: '',
        buyerMobile: '',
        buyerEmail: '',
      },
      regionParams: { dictType: 'region' },
      shipPlanTypeParams: { dictType: 'shipPlanType' },
      chooseScmContactsVisible: false,
    }
  },
  computed: {
    formRules() {
      return {
        bookContractNo: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        custCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        buyerCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        amazonStoreRegion: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        regionCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        shipPlanType: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        shipmentByFactory: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        ecomWarehouseCode: [
          {
            required: this.formData.shipmentByFactory == 'N',
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        whContactName: [
          {
            required: this.formData.shipmentByFactory == 'N',
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
          {
            required: this.formData.shipmentByFactory == 'N',
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'change',
          },
        ],
        whContactMobile: [
          {
            required: this.formData.shipmentByFactory == 'N',
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
          {
            required: this.formData.shipmentByFactory == 'N',
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'change',
          },
        ],
        whContactEmail: [
          {
            required: this.formData.shipmentByFactory == 'N',
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
          {
            required: this.formData.shipmentByFactory == 'N',
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'change',
          },
        ],
        scmCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        scmContactName: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'change',
          },
        ],
        scmContactMobile: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'change',
          },
        ],
        scmContactEmail: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'change',
          },
        ],
        deliveryDate: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        operationRequirement: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'change',
          },
        ],
        comfirmDeliveryDate: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        carrierName: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        carrierInfo: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
      }
    },
    ...mapState('admin/user', ['info']),
  },
  watch: {
    info: {
      handler(userInfo) {
        if (this.amzFtyNoticeOutCode) return
        if (!userInfo || userInfo === {}) return
        const { userCode, userName, userNameEn } = userInfo
        this.formData.buyerCode = userCode || ''
        this.formData.buyerName = [userNameEn, userName]
          .filter(Boolean)
          .join('-')
        this.buyerChange(userCode)
      },
      immediate: true,
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    reload() {
      this.getData()
      this.$refs.skuTable.getData()
    },
    async custLoaded(data) {
      if (!this.amzFtyNoticeOutCode) {
        data.forEach((element) => {
          if (element.label.toLowerCase() == 'Amazon'.toLowerCase()) {
            this.$refs.custRef.change(element.value)
          }
        })
      }
    },
    async getData() {
      if (!this.amzFtyOutboundCode) return
      const res = await this.$api
        .ecomAmzFtyOutboundDetailApi({
          amzFtyOutboundCode: this.amzFtyOutboundCode,
        })
        .catch(() => null)
      if (!res) return
      this.formData = res.body || {}
    },
    async buyerChange(code) {
      if (!code) return
      const res = await request({
        url: '/sys/user/detail',
        method: 'POST',
        data: { userCode: code },
      }).catch(() => null)
      if (!res) return
      const { mobileNumber, emailAddress } = res.body
      this.formData.buyerMobile = mobileNumber
      this.formData.buyerEmail = emailAddress
    },
    async warehouseChange(code) {
      if (!code) return
      const res = await request({
        url: '/ecom/warehouse/detail',
        method: 'POST',
        data: { ecomWarehouseCode: code },
      }).catch(() => null)
      if (!res) return

      const { whContactName, whContactMobile, whContactEmail } = res.body
      this.formData.whContactName = whContactName
      this.formData.whContactMobile = whContactMobile
      this.formData.whContactEmail = whContactEmail
    },
    shipmentByFactoryChange(val) {
      if ('Y' === val) {
        this.formData.ecomWarehouseCode = ''
        this.formData.whContactName = ''
        this.formData.whContactMobile = ''
        this.formData.whContactEmail = ''
        this.$refs.ecomWarehouse.clearValidate()
        this.scmChange(this.formData.scmCode)
      }
    },
    async scmChange(code) {
      if (!code || this.formData.shipmentByFactory == 'N') return
      const res = await request({
        url: '/digitalCenter/scmInfoContacts/list',
        method: 'POST',
        data: { scmCode: code },
      }).catch(() => null)
      if (!res) return

      const { data } = res.body
      if (!data || !data.length) return
      if (data.length > 1) return (this.chooseScmContactsVisible = true)

      const { contactName, contactMobile, contactEmail } = data[0]
      this.formData.scmContactName = contactName
      this.formData.scmContactMobile = contactMobile
      this.formData.scmContactEmail = contactEmail
    },
    scmContactsConfirm(data) {
      if (!data?.length) return
      const contactName = [
        ...new Set(data.map((item) => item.contactName).filter(Boolean)),
      ].join()
      const contactMobile = [
        ...new Set(data.map((item) => item.contactMobile).filter(Boolean)),
      ].join()
      const contactEmail = [
        ...new Set(data.map((item) => item.contactEmail).filter(Boolean)),
      ].join()
      this.formData.scmContactName = contactName
      this.formData.scmContactMobile = contactMobile
      this.formData.scmContactEmail = contactEmail
    },
    async save() {
      if (!(await this.validate())) return

      const details = await this.$refs.skuTable.getTableData()

      this.loadingOpen()
      const params = { ...this.formData, details }
      const res = await this.$api
        .ecomAmzFtyOutboundSaveApi(params)
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status, body } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })

      if (this.amzFtyOutboundCode) {
        this.reload()
        return
      }

      const { amzFtyOutboundCode = '', amzFtyOutboundNo = '' } = body || {}
      if (amzFtyOutboundCode) {
        this.$router.replace({
          name: 'ecom-awsBiz-ftyOutbound-detail',
          params: { amzFtyOutboundCode, pageType: 'edit' },
          query: { amzFtyOutboundNo },
        })
        return
      }
    },
    async validate() {
      const baseForm = await validate.formValidate([this.$refs.baseForm])
      const carrierForm = await validate.formValidate([this.$refs.carrierForm])
      const skuResult = await this.$refs.skuTable.validate()
      return baseForm && carrierForm && skuResult
    },
    async closeCurPage() {
      // 关闭当前页面
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
.span-style {
  font-size: 30px;
  line-height: 22px;
  color: #888888;
}
</style>
